import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { EquipmentService } from '../../../services/equipment.service';


@Component({
  selector: 'app-description-picker',
  templateUrl: './description-picker.component.html',
  styleUrls: ['./description-picker.component.scss']
})
export class DescriptionPickerComponent implements OnInit, OnChanges {
  @Input() id: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onIdSet = new EventEmitter<number>();
  @Output() onSet = new EventEmitter<any>();

  descriptions = [];


  constructor(public equipmentService: EquipmentService) {
  }

  ngOnInit(): void {
    this.equipmentService.getDescriptions().then((descriptions) => {
      this.descriptions = descriptions;
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    if (changes.item_Code != null && changes.item_Code.currentValue) {
      if (this.id != changes.item_Code.currentValue)
        this.id = changes.item_Code.currentValue;
    }

  }

  onChanged() {
    this.onIdSet.emit(this.id);
    var category = this.descriptions.find(a => a.id == this.id);
    this.onSet.emit(category);
  }

}
